/**
 * Ouverture VOLONTAIRE de l'onboarding radio via l'URL (?step=subscription_sound) :
 * menu « Mon abonnement radio », CTA des cards dashboard. Interceptée par
 * RequiredActionsProvider, qui ouvre la dialog des actions obligatoires puis nettoie l'URL.
 */
export const QUERY_SOUND_SUBSCRIPTION = 'subscription_sound'

/**
 * Marqueur de RETOUR d'un service externe (Stripe, Universign) posé dans la redirectUrl par
 * useOnboardingSound (?soundReturn=<étape de provenance>). Traité par
 * SoundOnboardingFinalizeDialog : invalidations, puis reprise sur l'étape suivante (dialog
 * des actions obligatoires) ou écran de félicitations si tout est terminé.
 * Remplace l'ancien `?status=success` ambigu (posé par TOUTE signature/souscription), qui
 * faisait sauter le tunnel italien sur l'écran de fin dès le retour du contrat.
 */
export const QUERY_SOUND_RETURN = 'soundReturn'

/** Valeurs du marqueur : étape depuis laquelle on est parti vers le service externe. */
export const SOUND_RETURN_STEP = {
  SUBSCRIPTION: 'subscription',
  CONTRACT: 'contract',
  RIGHTS: 'rights',
} as const
